var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{staticClass:"cursor-pointer cursor-pointer mt-1 sm:mr-6 mr-2",attrs:{"icon":"BellIcon","badge":_vm.unReadCount},on:{"click":function($event){return _vm.iconClick()}}})}
var staticRenderFns = []

export { render, staticRenderFns }